import React from "react";
import HeaderTab from "../../common/components/HeaderTab";

import { PALETTE } from "../../common/ThemeConstants";
import Logo from "../../common/images/logo.png";

import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  NavbarResponsive,
  isiOS,
  isRunningStandalone,
} from "../../common/components/NavbarResponsive";

export default function HomeHeader({ isLogged, categories }) {
  return (
    <NavbarResponsive>
      <Container>
        <Navbar.Brand href="/">
          <img
            className="d-block"
            width={70}
            src={Logo}
            alt="Federico Bartoli PT"
          ></img>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Offcanvas placement="end">
          <Offcanvas.Header
            closeButton
            style={{ marginTop: !isiOS() && isRunningStandalone() && 0 }}
          >
            <Offcanvas.Title>
              <img
                className="d-block"
                width={100}
                src={Logo}
                alt="Federico Bartoli PT"
              ></img>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="me-auto ms-auto">
              {categories.length > 0 &&
                categories.map((category) => (
                  <HeaderTab
                    key={category.id}
                    url={"/account/Workouts/" + category.name}
                    text={category.name}
                    color={PALETTE.DARKGRAY}
                    activeColor={PALETTE.DARK}
                  />
                ))}
              {/* <HeaderTab
                                key={50}
                                url={"/#generalAdvises"}
                                text={"General advises"}
                                isActive={appState.appMode === "GeneralAdvises"}
                                color={PALETTE.GRAY}
                                activeColor={PALETTE.DARK}
                            /> */}
            </Nav>
            <Nav>
              <HeaderTab
                url={isLogged ? "/account/Profile/Skills" : "/login"}
                text={isLogged ? "Account" : "Login"}
                color={PALETTE.DARKGRAY}
                activeColor={PALETTE.DARK}
              />
              <NavDropdown
                title={<span style={{ color: PALETTE.GRAY }}>IT</span>}
                id="nav-dropdown"
                menuVariant="dark"
              >
                <NavDropdown.Item className="rounded-md" href="/">
                  IT
                </NavDropdown.Item>
                {/* <NavDropdown.Item href="/#generalAdvises">ES</NavDropdown.Item> */}
              </NavDropdown>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </NavbarResponsive>
  );
}
